import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, resolveComponent as _resolveComponent, createVNode as _createVNode, createTextVNode as _createTextVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
import _imports_0 from '@/assets/img/Icons/buttons/send.svg'


const _withScopeId = (n: any) => (_pushScopeId("data-v-861ea6ce"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "block-message" }
const _hoisted_2 = {
  class: "content-messages",
  id: "content-messages"
}
const _hoisted_3 = { class: "item-message" }
const _hoisted_4 = {
  key: 0,
  class: "avatar"
}
const _hoisted_5 = {
  key: 1,
  class: "avatar"
}
const _hoisted_6 = { class: "message" }
const _hoisted_7 = { class: "date" }
const _hoisted_8 = { class: "footer-messages" }
const _hoisted_9 = { class: "wrapper-btn-send" }
const _hoisted_10 = ["disabled"]
const _hoisted_11 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", { src: _imports_0 }, null, -1))

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_ui_input = _resolveComponent("ui-input")!

  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.Messages, (message) => {
        return (_openBlock(), _createElementBlock("div", {
          class: _normalizeClass(["message-container", {
					'message-from': !message.IsPersonMessage,
					'message-to': message.IsPersonMessage,
				}]),
          key: message.Id
        }, [
          _createElementVNode("div", _hoisted_3, [
            (!message.IsPersonMessage)
              ? (_openBlock(), _createElementBlock("div", _hoisted_4, _toDisplayString(_ctx.$localization.getTranslate("Administrator")) + ": ", 1))
              : (_openBlock(), _createElementBlock("div", _hoisted_5, _toDisplayString(_ctx.$localization.getTranslate("You")) + ":", 1)),
            _createElementVNode("div", _hoisted_6, _toDisplayString(message.Text), 1)
          ]),
          _createElementVNode("div", _hoisted_7, _toDisplayString(new Date(message.DateCreateJs).toLocaleDateString("ru", _ctx.options)), 1)
        ], 2))
      }), 128))
    ]),
    _createElementVNode("div", _hoisted_8, [
      _createVNode(_component_ui_input, {
        modelValue: _ctx.TextMessage,
        "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.TextMessage) = $event)),
        placeholder: _ctx.$localization.getTranslate('EnterYourMessage'),
        onKeyupEnter: _ctx.SendMessage
      }, null, 8, ["modelValue", "placeholder", "onKeyupEnter"]),
      _createElementVNode("div", _hoisted_9, [
        _createElementVNode("button", {
          class: "ui_continue_button",
          onClick: _cache[1] || (_cache[1] = 
//@ts-ignore
(...args) => (_ctx.SendMessage && _ctx.SendMessage(...args))),
          disabled: !_ctx.TextMessage
        }, [
          _hoisted_11,
          _createTextVNode("  "),
          _createElementVNode("span", null, _toDisplayString(_ctx.$localization.getTranslate("Send")), 1)
        ], 8, _hoisted_10)
      ])
    ])
  ]))
}